export class PostalCode {
  static isValid(source: string | number, prefixNumberCount?: number): boolean {
    if (!source) {
      throw new Error("illegal argument. source : " + source);
    }
    if (prefixNumberCount && (prefixNumberCount < 3)) {
      throw new Error("illegal argument. prefixNumberCount(" + prefixNumberCount + ") < 3.");
    }
    return PostalCode.isValidString(this.toString(source), !prefixNumberCount ? 7 : prefixNumberCount);
  }

  private static toString(source: string | number): string {
    if (typeof source === "number") {
      return ("0000000" + source).slice(-7);
    } else {
      return source;
    }
  }

  private static isValidString(source: string, prefixNumberCount: number): boolean {
    return (source.match(PostalCode._expression) && ((prefixNumberCount + ((3 < prefixNumberCount) ? 1 : 0)) <= source.length))
      || (source.match(PostalCode._numberOnlyExpression) && (prefixNumberCount <= source.length));
  }

  private static _numberOnlyExpression = /^\d{3}\d{0,4}$/;
  private static _expression = /^\d{3}-?\d{0,4}$/;

  static format(source: string | number, needsHyphen: boolean = true): string {
    if (!PostalCode.isValid(source)) {
      throw new Error("illegal argument. invalid format. : " + source);
    }
    return PostalCode.formatFromString(PostalCode.toString(source), needsHyphen);
  }

  private static formatFromString(source: string, needsHyphen: boolean): string {
    const trimmed = source.replace(/-/, "");
    return trimmed.substr(0, 3)
      + (needsHyphen ? "-" : "")
      + trimmed.substr(3, 4);
  }
}
